"use client";

import React, { useState } from "react";
import { StyledSection } from "./quickAnswers.styles";

export interface IQuickAnswer {
  question: string;
  answer: string;
}

interface IQuickAnswersProps {
  title?: string;
  eyebrow?: string;
  items: IQuickAnswer[];
  defaultOpenIndex?: number;
}

export const QuickAnswers = ({
  title = "Quick answers",
  eyebrow = "FAQ",
  items,
  defaultOpenIndex = 0,
}: IQuickAnswersProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpenIndex);

  if (!items.length) return null;

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <StyledSection>
      <div className="inner">
        <header>
          <span className="eyebrow">{eyebrow}</span>
          <h2>{title}</h2>
        </header>
        <ul className="list">
          {items.map((it, i) => {
            const isOpen = openIndex === i;
            return (
              <li key={it.question} className={`item ${isOpen ? "open" : ""}`}>
                <button
                  type="button"
                  className="question"
                  aria-expanded={isOpen}
                  aria-controls={`qa-panel-${i}`}
                  onClick={() => toggle(i)}
                >
                  <span>{it.question}</span>
                  <span className="chevron" aria-hidden="true" />
                </button>
                <div
                  id={`qa-panel-${i}`}
                  className="answer"
                  role="region"
                  hidden={!isOpen}
                >
                  <p>{it.answer}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </StyledSection>
  );
};
